import {CFValue} from 'module/CustomField/type/CFType'
import chroma from 'chroma-js'
import {blackOrWhite} from 'util/Color'

export function adaptModelHexColorValue(modelValue: CFValue) {
	modelValue = typeof modelValue === 'number' ? modelValue.toString(16) : modelValue
	return !modelValue ? '' : modelValue + ''
}

export function ensureHexColorLenght(value: CFValue) {
	value = adaptModelHexColorValue(value)
	if (value && value.length === 3) value = [...value].flatMap(c => [c, c]).join('')
	return (value || "FFFFFF")
}

export function getColorsFromHexColorColumnValue(value: CFValue) {
	if (!value && value !== 0) return undefined
	value = adaptModelHexColorValue(value)
	if (value && value.length === 3) value = [...value].flatMap(c => [c, c]).join('')
	let background = '#' + ensureHexColorLenght(value)
	const valid = chroma.valid(background)
	if (!valid) return undefined
	const color = blackOrWhite(background)
	return {background, color}
}